var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMLogoLong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 43,
    viewBox: "0 0 200 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_2594)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.96 9.00003C98.7333 7.9167 96.8833 7.3667 94.46 7.3667C92.0367 7.3667 90.2 7.90337 89 9.00003C87.8 10.0967 87.1667 11.6067 87.1667 13.4867V29.09C87.1667 30.9734 87.8 32.4834 89.0433 33.5834C90.2867 34.6834 92.12 35.2134 94.5433 35.2134C96.9667 35.2134 98.8033 34.6634 100.007 33.58C101.21 32.4967 101.837 30.97 101.837 29.09V13.4767C101.837 11.5934 101.207 10.0834 99.96 9.00003ZM90.9433 13.4767C90.919 13.0997 90.9805 12.722 91.1231 12.3722C91.2657 12.0223 91.4857 11.7093 91.7667 11.4567C92.3333 10.97 93.24 10.7267 94.46 10.7267C95.68 10.7267 96.64 10.9734 97.2233 11.46C97.5055 11.708 97.7275 12.0169 97.8725 12.3635C98.0174 12.71 98.0816 13.085 98.06 13.46V29.09C98.0808 29.464 98.0174 29.8379 97.8743 30.1841C97.7312 30.5303 97.5122 30.8399 97.2333 31.09C96.6667 31.5867 95.7633 31.84 94.5433 31.84C93.3233 31.84 92.3667 31.5867 91.7867 31.0867C91.5037 30.8391 91.2807 30.5304 91.1346 30.1839C90.9885 29.8374 90.9231 29.4622 90.9433 29.0867V13.4767Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.333 9.00003C119.103 7.9167 117.253 7.3667 114.833 7.3667C112.413 7.3667 110.573 7.90337 109.373 9.00003C108.173 10.0967 107.543 11.6067 107.543 13.4867V29.09C107.543 30.9734 108.173 32.4834 109.42 33.5834C110.667 34.6834 112.497 35.2134 114.917 35.2134C117.337 35.2134 119.18 34.6634 120.38 33.58C121.58 32.4967 122.21 30.97 122.21 29.09V14C122.21 12.3767 121.72 10.2067 120.333 9.00003ZM111.333 13.4767C111.309 13.0997 111.37 12.722 111.513 12.3722C111.656 12.0223 111.876 11.7093 112.157 11.4567C112.723 10.97 113.63 10.7267 114.853 10.7267C116.077 10.7267 117.033 10.9734 117.613 11.46C117.896 11.7078 118.118 12.0167 118.264 12.3632C118.409 12.7097 118.474 13.0848 118.453 13.46V29.09C118.474 29.464 118.411 29.8379 118.268 30.1841C118.125 30.5303 117.905 30.8399 117.627 31.09C117.06 31.5867 116.153 31.84 114.933 31.84C113.713 31.84 112.757 31.5867 112.177 31.0867C111.894 30.8391 111.671 30.5304 111.525 30.1839C111.378 29.8374 111.313 29.4622 111.333 29.0867V13.4767Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.333 23.2799L133.087 16.3133C132.579 15.8971 132.186 15.3577 131.947 14.7466L131.893 14.5766C131.747 14.1735 131.683 13.7449 131.707 13.3166C131.687 12.9647 131.746 12.6129 131.879 12.2866C132.012 11.9603 132.216 11.6676 132.477 11.4299C133.003 10.9633 133.86 10.7266 135.023 10.7266C136.187 10.7266 137.043 10.9633 137.57 11.4299C137.831 11.6701 138.035 11.9657 138.167 12.295C138.3 12.6244 138.356 12.9792 138.333 13.3333V16.8566H142.11V13.4766C142.11 11.6033 141.537 10.0966 140.413 8.99994C139.29 7.90327 137.513 7.35327 135.137 7.35327C132.76 7.35327 130.913 7.90327 129.727 8.99994C128.54 10.0966 127.917 11.6066 127.917 13.4866C127.887 14.3762 128.057 15.2611 128.413 16.0766C128.839 17.0781 129.46 17.9847 130.24 18.7433L137.333 25.6666C137.841 26.1036 138.234 26.6572 138.48 27.2799C138.655 27.9181 138.736 28.5784 138.72 29.2399C138.733 29.5917 138.666 29.9418 138.523 30.2636C138.381 30.5854 138.166 30.8703 137.897 31.0966C137.33 31.5833 136.423 31.8299 135.203 31.8299C133.983 31.8299 133.073 31.5833 132.507 31.0966C132.237 30.8703 132.023 30.5854 131.88 30.2636C131.737 29.9418 131.67 29.5917 131.683 29.2399V25.1866H127.917V29.0899C127.917 30.9666 128.52 32.4766 129.703 33.5733C130.887 34.6699 132.733 35.2133 135.213 35.2133C137.693 35.2133 139.58 34.6633 140.74 33.5733C141.9 32.4833 142.507 30.9666 142.507 29.0899C142.53 28.0246 142.378 26.9626 142.057 25.9466C141.671 24.9493 141.084 24.0417 140.333 23.2799Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.75 9.00003C176.52 7.9167 174.67 7.3667 172.25 7.3667C169.83 7.3667 168 7.90337 166.787 9.00003C165.573 10.0967 164.957 11.6067 164.957 13.4867V29.09C164.957 30.9734 165.587 32.4834 166.833 33.5834C168.08 34.6834 169.91 35.2134 172.33 35.2134C174.75 35.2134 176.593 34.6634 177.793 33.58C178.993 32.4967 179.623 30.97 179.623 29.09V13.4767C179.623 11.5934 179 10.0834 177.75 9.00003ZM168.733 13.4767C168.708 13.0999 168.769 12.7224 168.911 12.3725C169.053 12.0226 169.273 11.7095 169.553 11.4567C170.12 10.97 171.027 10.7267 172.25 10.7267C173.473 10.7267 174.43 10.9734 175.01 11.46C175.293 11.7073 175.516 12.0161 175.662 12.3627C175.807 12.7094 175.872 13.0847 175.85 13.46V29.09C175.871 29.464 175.807 29.8379 175.664 30.1841C175.521 30.5303 175.302 30.8399 175.023 31.09C174.457 31.5867 173.55 31.84 172.33 31.84C171.11 31.84 170.153 31.5867 169.573 31.0867C169.291 30.8389 169.068 30.5301 168.923 30.1836C168.777 29.837 168.712 29.462 168.733 29.0867V13.4767Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.123 9.00003C196.897 7.9167 195.047 7.3667 192.627 7.3667C190.207 7.3667 188.363 7.90337 187.163 9.00003C185.963 10.0967 185.333 11.5967 185.333 13.4767V29.09C185.333 30.9734 185.963 32.4834 187.207 33.5834C188.45 34.6834 190.283 35.2134 192.707 35.2134C195.13 35.2134 196.967 34.6634 198.17 33.58C199.373 32.4967 200 30.97 200 29.09V13.4767C200 11.5934 199.37 10.0834 198.123 9.00003ZM189.123 13.49C189.099 13.113 189.16 12.7354 189.303 12.3855C189.446 12.0356 189.666 11.7226 189.947 11.47C190.513 10.9834 191.42 10.74 192.643 10.74C193.867 10.74 194.82 10.9867 195.403 11.4734C195.686 11.7213 195.908 12.0303 196.052 12.3768C196.197 12.7233 196.262 13.0983 196.24 13.4734V29.09C196.261 29.464 196.197 29.8379 196.054 30.1841C195.911 30.5303 195.692 30.8399 195.413 31.09C194.847 31.5867 193.943 31.84 192.723 31.84C191.503 31.84 190.547 31.5867 189.967 31.0867C189.684 30.8391 189.461 30.5304 189.315 30.1839C189.168 29.8374 189.103 29.4622 189.123 29.0867V13.49Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.82 7.6167C75.0233 7.6167 75.2167 7.6167 75.4067 7.6167L75.74 7.64337C76.1405 7.67461 76.5382 7.73476 76.93 7.82337C77.4609 7.94202 77.9703 8.14217 78.44 8.4167C79.3152 8.93594 80.0037 9.71889 80.4067 10.6534C80.4467 10.75 80.4833 10.8467 80.52 10.9467C80.5767 11.1034 80.63 11.26 80.6767 11.4234C80.8901 12.1723 80.9956 12.9479 80.99 13.7267V35.1334H77.21V13.74C77.2363 13.0229 77.0645 12.3125 76.7133 11.6867C76.43 11.2234 75.78 10.9867 74.78 10.9867H70.6967V35.1334H66.9233V13.74C66.9502 13.0229 66.7783 12.3123 66.4267 11.6867C66.1433 11.2234 65.4933 10.9867 64.4933 10.9867H60.41V35.1334H56.6333V7.63003H62.1833H74.0033L74.82 7.6167Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.473 29.6667C155.485 30.2341 155.32 30.7912 155 31.26C154.862 31.4573 154.674 31.615 154.456 31.7173C154.238 31.8197 153.997 31.8631 153.757 31.8433C153.507 31.8631 153.256 31.8194 153.028 31.7163C152.799 31.6131 152.6 31.4539 152.45 31.2534C152.134 30.7863 151.976 30.2301 152 29.6667V13.6667H159.24V10.2867H152V7.43335H148.213V29.4934C148.213 31.3734 148.747 32.8267 149.8 33.7767C150.889 34.7491 152.311 35.2637 153.77 35.2133C155.22 35.2693 156.635 34.752 157.707 33.7734C158.73 32.81 159.25 31.37 159.25 29.4934V24.38H155.473V29.6667Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 0H0V20.3333C0.00441142 24.3102 1.58618 28.123 4.39827 30.9351C7.21036 33.7472 11.0231 35.3289 15 35.3333H35.3333L42.6667 42.6667V15C42.6623 11.0231 41.0805 7.21036 38.2684 4.39827C35.4563 1.58618 31.6436 0.00441142 27.6667 0ZM15 28C12.9667 28 11.0166 27.1923 9.57885 25.7545C8.14107 24.3167 7.33333 22.3667 7.33333 20.3333V7.33333H27.6667C29.7 7.33333 31.65 8.14107 33.0878 9.57885C34.5256 11.0166 35.3333 12.9667 35.3333 15V28H15Z",
    fill: "url(#paint0_linear_250_2594)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.6666C17.5773 19.6666 19.6667 17.5772 19.6667 14.9999C19.6667 12.4226 17.5773 10.3333 15 10.3333C12.4227 10.3333 10.3333 12.4226 10.3333 14.9999C10.3333 17.5772 12.4227 19.6666 15 19.6666Z",
    fill: "url(#paint1_linear_250_2594)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_2594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 10,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.6666C17.5773 19.6666 19.6667 17.5772 19.6667 14.9999C19.6667 12.4226 17.5773 10.3333 15 10.3333C12.4227 10.3333 10.3333 12.4226 10.3333 14.9999C10.3333 17.5772 12.4227 19.6666 15 19.6666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9033 -0.0966797H0.17667V35.59H41.9033V-0.0966797Z",
    fill: "url(#paint2_linear_250_2594)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 25.0001C30.244 25.0001 32.3333 22.9107 32.3333 20.3334C32.3333 17.7561 30.244 15.6667 27.6667 15.6667C25.0893 15.6667 23 17.7561 23 20.3334C23 22.9107 25.0893 25.0001 27.6667 25.0001Z",
    fill: "url(#paint3_linear_250_2594)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_250_2594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 15,
    width: 10,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 25.0001C30.244 25.0001 32.3333 22.9107 32.3333 20.3334C32.3333 17.7561 30.244 15.6667 27.6667 15.6667C25.0893 15.6667 23 17.7561 23 20.3334C23 22.9107 25.0893 25.0001 27.6667 25.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_250_2594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.49 -0.253174H0.763336V35.4335H42.49V-0.253174Z",
    fill: "url(#paint4_linear_250_2594)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_2594",
    x1: 0,
    y1: 21.3333,
    x2: 42.6667,
    y2: 21.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B92F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2364CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0B4EAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_2594",
    x1: 10.3333,
    y1: 14.9999,
    x2: 19.6667,
    y2: 14.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B92F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2364CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0B4EAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_2594",
    x1: 1.68667,
    y1: -1.60668,
    x2: 40.3933,
    y2: 37.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B92F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2364CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0B4EAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_250_2594",
    x1: 23,
    y1: 20.3334,
    x2: 32.3333,
    y2: 20.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B92F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2364CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0B4EAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_250_2594",
    x1: 2.27334,
    y1: -1.76317,
    x2: 40.98,
    y2: 36.9402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B92F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2364CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0B4EAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_2594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 42.6667,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogoLong);
export default __webpack_public_path__ + "static/media/m-logo-long.eca2a014.svg";
export { ForwardRef as ReactComponent };